// extracted by mini-css-extract-plugin
export default {"loader":"AppLoader_loader__7aWe5","glow":"AppLoader_glow__UBlnv"};